import { isAppsAndFiltersPreview } from "../appsAndFiltersPreview";

export const isEngagementAsyncCampaignPreviewAppGroupIdResult = isAppsAndFiltersPreview;
